import classNames from 'classnames';
import React from 'react';

import { InfoCircle, SmilieHappy, SmilieSad } from '@zooplus/icons';

import styles from './Notification.module.scss';

export type Props = {
  type?: 'success' | 'warning' | 'info';
  id: string;
  ariaLabel: string;
  text: string;
};

const RetryNotificationBanner: React.FC<Props> = ({
  type = 'info',
  id,
  ariaLabel,
  children,
  text,
}) => {
  return (
    <div
      className={classNames(styles.notification, `v3-notification v3-notification--${type}`)}
      role="alertdialog"
      data-zta={id}
      aria-labelledby={ariaLabel}
      aria-describedby={id}
      aria-label={ariaLabel}>
      <div className={classNames('v3-notification__body', styles.notificationFlow)}>
        <div className={styles.iconTextWrapper}>
          <i className={`v3-notification__icon--${type}`}>
            {type === 'warning' && <SmilieSad data-zta="smilie-sad" />}
            {type === 'success' && <SmilieHappy data-zta="smilie-happy" />}
            {type === 'info' && <InfoCircle data-zta="info-circle" />}
          </i>
          <div id={id} className="v3-notification__text">
            {text}
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default RetryNotificationBanner;
